export var internalProps = {
    publicData: '_publicData',
};
//# sourceMappingURL=internalProps.js.map